var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExitFullScreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5607 2.56066C30.1464 1.97487 30.1464 1.02513 29.5607 0.43934C28.9749 -0.146447 28.0251 -0.146447 27.4393 0.43934L21 6.87868L21 4.49999C21 3.67156 20.3284 2.99999 19.5 2.99999C18.6716 2.99999 18 3.67157 18 4.49999L18 10.5C18 11.3284 18.6716 12 19.5 12L25.5 12C26.3284 12 27 11.3284 27 10.5C27 9.67157 26.3284 9 25.5 9L23.1213 9L29.5607 2.56066ZM0.43934 29.5607C-0.146447 28.9749 -0.146447 28.0251 0.43934 27.4393L6.87868 21H4.5C3.67157 21 3 20.3284 3 19.5C3 18.6716 3.67157 18 4.5 18H10.5C11.3284 18 12 18.6716 12 19.5L12 25.5C12 26.3284 11.3284 27 10.5 27C9.67158 27 9 26.3284 9 25.5L9 23.1213L2.56066 29.5607C1.97487 30.1464 1.02513 30.1464 0.43934 29.5607Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExitFullScreen);
export default __webpack_public_path__ + "static/media/exit-full-screen.35c45e18a3cbcdf05f223411c464f54b.svg";
export { ForwardRef as ReactComponent };